import React from 'react';

const Stats = () => {
  const stats = [
    {
      number: '99.9%',
      title: 'Uptime',
      icon: 'fa-server'
    },
    {
      number: '24/7',
      title: 'Support',
      icon: 'fa-headset'
    },
    {
      number: '***',
      title: 'Users',
      icon: 'fa-users'
    },
    {
      number: '30+',
      title: 'Locations',
      icon: 'fa-globe'
    }
  ];

  return (
    <section className="stats py-3 py-md-4 position-relative overflow-hidden" style={{
      backgroundColor: '#0f172a',
      backgroundImage: `
        linear-gradient(135deg, rgba(30, 41, 59, 0.9) 0%, rgba(15, 23, 42, 0.95) 100%),
        radial-gradient(circle at 10% 20%, rgba(56, 189, 248, 0.1) 0%, transparent 20%),
        radial-gradient(circle at 90% 80%, rgba(59, 130, 246, 0.1) 0%, transparent 20%)
      `,
      borderTop: '1px solid rgba(255, 255, 255, 0.03)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.03)',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
    }}>
      {/* Subtle grid pattern */}
      <div className="position-absolute top-0 start-0 w-100 h-100" style={{
        backgroundImage: `
          linear-gradient(rgba(255, 255, 255, 0.02) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255, 255, 255, 0.02) 1px, transparent 1px)
        `,
        backgroundSize: '30px 30px',
        opacity: 0.3,
        pointerEvents: 'none'
      }}></div>
      <div className="container">
        <div className="row g-0">
          {stats.map((stat, index) => (
            <div 
              className="col-6 col-md-3 position-relative" 
              key={index} 
              data-aos="fade-up" 
              data-aos-delay={index * 100}
            >
              {index < stats.length - 1 && (
                <div className="position-absolute top-0 end-0 h-100 d-none d-md-block" style={{
                  width: '1px',
                  background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.1), transparent)'
                }}></div>
              )}
              <div className="stat-card h-100 p-3 p-md-4 text-center">
                <div className="icon mb-1 mb-md-2">
                  <i 
                    className={`fas ${stat.icon} fa-2x`} 
                    style={{
                      color: '#3b82f6',
                      background: 'rgba(59, 130, 246, 0.1)',
                      width: '50px',
                      height: '50px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '12px',
                      marginBottom: '0.5rem'
                    }}
                  ></i>
                </div>
                <div className="number fs-3 fw-bold mb-0" style={{ 
                  color: '#f8fafc',
                  textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                }}>{stat.number}</div>
                <div className="text-uppercase small fw-medium" style={{ 
                  letterSpacing: '0.5px',
                  color: '#94a3b8',
                  fontWeight: '500',
                  textShadow: '0 1px 1px rgba(0, 0, 0, 0.1)'
                }}>{stat.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
